import React, { Component } from 'react';
import './theme.css';

class FooterBar extends Component {
  /*constructor(props)
  {
    super(props);
  }*/

  render(){
    return(
      <footer className="footerbar">
              <i className="material-icons footerbar">info </i> Artworks by bezo97 - Copyright (c) {new Date().getFullYear()}, Dócs Zoltán - <a data-email="bezozo97@gmail.com" href="mailto:bezozo97@gmail.com">Contact</a>
      </footer>
    );
  }
}

export default FooterBar



// WEBPACK FOOTER //
// ./src/Component/FooterBar.js